import React, { useState, Component } from 'react';
import classNames from 'classnames';
import * as XLSX from 'xlsx';
import { featureCollectionToTurfPolygons } from './helpers/createTurfPolygons';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import { REACT_APP_API_BASE, REACT_APP_GEOJSON_LOCATION, getSalesSpaceGroupFromRetailArea } from '../../config';
import Takeover from '../takeover';
import SpinnerDots from '../spinner/dots';
import DropdownButton from '../dropdown-button';
import './import.scss';

const View1  = props => {
    const [value, handleChange] = useState(props.unitColumnIndex);

    return (
        <div className="import__content">
            <label htmlFor="districtConnectingCol" className="districts__destination-lbl">Välj kolumn för att koppla mot Delfis register. Vi kan matcha Delfi Nr och EDI -nummer. Vi kunde hitta följande rubriker i din excelfil:</label>
            <div className="form__select districts__destination">
                <select id="districtConnectingCol" value={value} onChange={(e) => handleChange(e.target.value)}>
                    <option value=''>Välj</option>
                    {props.columns.map((item, i) => {
                        return (
                            <option key={`column${i}`} value={i}>{item}</option>
                        );
                    })}
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success districts__takeover-controls-btn--wide" type="button" disabled={value === ''} onClick={() => props.onNext(value)}>Nästa</button>
            </div>
        </div>
    );
};

const View2 = props => {
    
    const [value, handleChange] = useState(props.districtColumnIndex);
    const [isOpen, toggleUnmatched] = useState(false);

    return (
        <div className="import__content">
            <div className="import__report">
                <p>Vi matchade <strong>{props.matchedUnits && props.matchedUnits.length}</strong> enheter i Delfis register av importfilens totalt <strong>{props.allRows.length}</strong> butiker.
                    {(props.unMatchedUnits && props.unMatchedUnits.length > 0) &&
                        <button className={classNames({
                            'import__unmatched-toggle': true,
                            'import__unmatched-toggle--is-open': isOpen,
                        })} type="button" onClick={() => toggleUnmatched(!isOpen)}>{isOpen ? 'Stäng logg' : 'Visa logg'}</button>
                    }
                </p>
                {props.unMatchedUnits &&  props.unMatchedUnits.length > 0 && isOpen &&
                    <div className="import__unmatched">
                        <p>Följande enheter kunde vi inte hitta en matchning för i Delfis register:</p>
                        <ul>
                            {props.unMatchedUnits.map(unit => {
                                return (
                                    <li>{unit}</li>
                                );
                            })}
                        </ul>
                    </div>
                }
            </div>
            
            <label htmlFor="districtNameCol" className="districts__destination-lbl">Välj kolumn i importfilen för säljdistriktsnamn. Vi kunde hitta följande rubriker i din excelfil:</label>
            <div className="form__select districts__destination">
                <select id="districtNameCol" value={value} onChange={(e) => handleChange(e.target.value)}>
                    <option value=''>Välj</option>
                    {props.columns.map((item, i) => {
                        return (
                            <option key={`column${i}`} value={i}>{item}</option>
                        );
                    })}
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}>Föregående</button>
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success" type="button" disabled={value === ''} onClick={() => props.onNext(value)}>Nästa</button>
            </div>
        </div>
    );
};

const View3 = props => {
    
    const [geoValue, handleGeoLayer] = useState(props.geoType);

    return (
        <div className="import__content">
            <label htmlFor="district-val" className="districts__destination-lbl">Hur vill du skapa din geografiska indelning?</label>
            <div className="form__select districts__destination">
                <select id="district-val" value={geoValue} onChange={(e) => handleGeoLayer(e.target.value)}>
                    <option value=''>Välj</option>
                    <option value="zip1">1-siffriga postnummer</option>
                    <option value="zip2">2-siffriga postnummer</option>
                    <option value="zip3">3-siffriga postnummer</option>
                    <option value="zip5">5-siffriga postnummer</option>
                    {props.type === 'livs' &&
                        <option value="county">Län</option>
                    }
                    <option value="municipality">Kommuner</option>
                    <option value="aregion">A-regioner</option>
                    {props.type === 'livs' &&
                        <option value="postalcity">Postorter</option>
                    }
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}>Föregående</button>
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success" type="button" disabled={geoValue === ''} onClick={() => props.onNext(geoValue)}>Nästa</button>
            </div>
        </div>
    );
};

const View4 = props => {
    
    const [geoValue, handleGeoLayer] = useState(props.geoType);

    return (
        <div className="import__content">
            <label htmlFor="district-val" className="districts__destination-lbl">Hur vill du skapa din geografiska indelning?</label>
            <div className="form__select districts__destination">
                <select id="district-val" value={geoValue} onChange={(e) => handleGeoLayer(e.target.value)}>
                    <option value=''>Välj</option>
                    <option value="zip5">Postnummer</option>
                    {props.type === 'livs' &&
                        <option value="county">Län</option>
                    }
                    <option value="municipality">Kommuner</option>
                    <option value="aregion">A-regioner</option>
                    {props.type === 'livs' &&
                        <option value="postalcity">Postorter</option>
                    }
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success districts__takeover-controls-btn--wide" type="button" disabled={geoValue === ''} onClick={() => props.onNext(geoValue)}>Nästa</button>
            </div>
        </div>
    );
};


const View5 = props => {
    const [value, handleChange] = useState(props.geoColumnIndex);

    return (
        <div className="import__content">
            <label htmlFor="geoCol" className="districts__destination-lbl">Välj kolumn i importfilen för <strong>{props.geoLayerName}</strong>. Vi kunde hitta följande rubriker i din excelfil:</label>
            <div className="form__select districts__destination">
                <select id="geoCol" value={value} onChange={(e) => handleChange(e.target.value)}>
                    <option value=''>Välj</option>
                    {props.columns.map((item, i) => {
                        return (
                            <option key={`column${i}`} value={i}>{item}</option>
                        );
                    })}
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}> Föregående</button>
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success" type="button" onClick={() => props.onNext(value)}>Nästa</button>
            </div>
        </div>
    );
};

const View6 = props => {
    const [value, handleChange] = useState(props.districtColumnIndex);

    return (
        <div className="import__content">
            <label htmlFor="districtNameCol" className="districts__destination-lbl">Välj kolumn i importfilen för säljdistriktsnamn. Vi kunde hitta följande rubriker i din excelfil:</label>
            <div className="form__select districts__destination">
                <select id="districtNameCol" value={value} onChange={(e) => handleChange(e.target.value)}>
                    <option value=''>Välj</option>
                    {props.columns.map((item, i) => {
                        return (
                            <option key={`column${i}`} value={i}>{item}</option>
                        );
                    })}
                </select>
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}>Föregående</button>
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success" type="button" disabled={value === ''} onClick={() => props.onNext(value)}>Nästa</button>
            </div>
        </div>
    );
};

const View7 = props => {

    const [scenarioId, handleScenarioChange] = useState(props.scenarioId);
    const [scenarioName, handleScenarioNameChange] = useState(props.scenarioName);

    return (
        <div className="import__content">
            <div className="import__report">
                <p>Till vilket scenario ska vi importera distrikten till?</p>
                <label className="districts__destination-lbl" htmlFor="scenario">Välj ett befintligt scenario:</label>
                <div className="form__select districts__destination">
                    <select id="scenario" value={scenarioId} onChange={(e) => handleScenarioChange(e.target.value)}>
                        <option value="">Välj</option>
                        {props.scenarios.map(item => {
                            return (
                                <option key={`scenario${item.salesDistrictScenarioId}`} value={item.salesDistrictScenarioId}>{item.name}</option>
                            );
                        })}
                    </select>
                </div>
                <p className="import__choose-scenario">- Eller skapa ett nytt scenario -</p>
                <label className="districts__destination-lbl" htmlFor="scenarioName">Scenarionamn:</label>
                <input className="districts__destination" id="scenarioName" placeholder="Skriv in ett scenarionamn" disabled={scenarioId !== ''} type="text" value={scenarioName} onChange={(e => handleScenarioNameChange(e.target.value))} />
            </div>
            <div className="import__footer">
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}>Föregående</button>
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success"  disabled={scenarioId === '' && scenarioName === ''} type="button" onClick={() => props.onNext(scenarioId, scenarioName)}>Nästa</button>
            </div>
        </div>
    );
};

const RegionToggler = props => {
    const [isOpen, toggleRegionSelector] = useState(false);

    return (
        <>
            <button onClick={() => toggleRegionSelector(!isOpen)} className="import__district-list-item-change-region" type="button">{`${props.getFullGeoLayerName(props.item.geoType)} - Ändra`}</button>
            {isOpen &&
                <div className="form__select import__district-list-item-region">
                    <select onChange={(e) => props.changeGeoTypeForDistrict(props.item.name, e.currentTarget.value, () => {
                        toggleRegionSelector(false);
                    })} value={props.item.geoType}>
                        <option value="zip1">1-siffrigt postnummer</option>
                        <option value="zip2">2-siffrigt postnummer</option>
                        <option value="zip3">3-siffrigt postnummer</option>
                        <option value="zip5">5-siffrigt postnummer</option>
                        <option value="county">Län</option>
                        <option value="municipality">Kommun</option>
                        <option value="aregion">A-region</option>
                        <option value="postalcity">Postort</option>
                    </select>
                </div>
            }
        </>
    );
};

const View8 = props => {
    return (
        <div className="import__content">
            <div className="import__report">
                <p>Följande distrikt kommer skapas:</p>
            </div>
            <ul className={classNames({
                'import__create-district-list': true,
                'import__create-district-list--is-creating': props.isCreating
            })}>
                {props.districts.map(item => {
                    return (
                        <li className={classNames({
                                'import__district-list-item': true,
                                'import__district-list-item--is-loading': item.isLoading,
                                'import__district-list-item--is-finished': item.isFinished,
                            })}
                            key={`districts${item.name}`}>
                            {props.isCreating &&
                                <SpinnerDots />
                            }
                            <div>    
                                {item.name} ({item.units.length} butiker)
                                {!item.isFinished && item.isLoading &&
                                    <div className="import__loading-bar" style={{width: `${item.load}%`}}></div>
                                }
                            </div>
                            {!props.isCreating && props.importFileType !== 'geo' &&
                                <RegionToggler {...props} item={item} />
                            }
                        </li>
                    );
                })}
            </ul>
            <div className="import__footer">
                {!props.isCreating &&
                    <button className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button" onClick={() => props.prevStep()}>Föregående</button>
                }
                <button className="districts__takeover-controls-btn districts__takeover-controls-btn--success"  disabled={props.isCreating} type="button" onClick={() => props.onNext()}>Skapa distrikt</button>
            </div>
        </div>
    );
};

const IsError = props => {
    return (
        <div className="import__content">
            <div className="import__error">
                {props.errorMessage}
            </div>
            <a href="/scenario" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Stäng</a>
        </div>
    );
};

class Import extends Component {
    
    state = {
        isOpen: false,
        isError: false,
        errorMessage: null,
        isLoading: false,
        isCreating: false,
        createDistrict: null,
        units: null,
        importFileType: 'unit',
        geoType: '',
        features: [],
        matchedUnits: null,
        unMatchedUnits: null,
        districts: null,
        document: null,
        view: 0, 
        step: 0,
        geoColumnIndex: '',
        unitColumnIndex: '',
        districtColumnIndex: '',
        scenarioId: '',
        scenarioName: ''
    };

    unitsWizardViewOrder = [1, 2, 3, 7, 8];
    geoWizardViewOrder = [4, 5, 6, 7, 8];

    async fetchNewDistrict(type, scenarioId) {
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrict/create/${type}${scenarioId ? `/${scenarioId}` : ''}`);
        return await res.json();
    }

    async fetchUnits(type) {        
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrict/units/${type}`);
        return await res.json();
    }

    async fetchGeoJSON(file) {
        const response = await fetch(file);
        return await response.json();    
    }

    prevStep() {
        this.setState({
            view: this.getView(this.state.step-2),
            step: this.state.step-1
        });
    }

    createTurnOverFilter(units) {
        const turnovers = units.map(unit => unit.turnoverClass*1);
        const turnoverLow = Math.min(...turnovers);
        const turnoverHigh = Math.max(...turnovers);
        return [turnoverLow, turnoverHigh];
    }

    createRetailAreaFilter(units) {
        const retailAreas = units.map(unit => {
            return getSalesSpaceGroupFromRetailArea(unit.retailArea)
        }).map(group => group.label);

        const retailAreaLow = Math.min(...retailAreas);
        const retailAreaHigh = Math.max(...retailAreas);
        return [retailAreaLow, retailAreaHigh];
        
    }

    createChainFilter(units, defaultChainFilter) {
        return defaultChainFilter.map(chain => {
            return {
                ...chain,
                selected: units.filter(unit => unit.chainCode*1 === chain.chainCode && unit.chainGroupCode*1 === chain.chainGroupCode).length > 0 ? true : false
            };
        });
    }

    getFilterDiff(unitsInExcel, allUnitsInArea, filters) {
        //Filter turnover
        const unitsFilteredTurnover = allUnitsInArea.filter(unit => {
            const turnOverClass = unit.turnoverClass*1;
            return turnOverClass >= filters.turnovers[0] && turnOverClass <= filters.turnovers[1];
        });

        const unitsFilterdChains = unitsFilteredTurnover.filter(unit => {
           return filters.chains.find(chain => chain.chainCode === unit.chainCode*1 && chain.chainGroupCode === unit.chainGroupCode*1 && chain.selected);
        });

        const unitsFilteredSalesSpaceGroup = unitsFilterdChains.filter(unit => {
            const group = getSalesSpaceGroupFromRetailArea(unit.retailArea);
            return group.label >= filters.salesSpaceGroups[0] && group.label <= filters.salesSpaceGroups[1];
        });

        //Diff
        const diff = unitsFilteredSalesSpaceGroup.filter(object1 => {
            return !unitsInExcel.some(object2 => {
              return object1.companyId === object2.companyId;
            });
        });

        return diff;
    }

    unitsToExclude(units, allUnitsInArea, filters) {
        const diff = this.getFilterDiff(units, allUnitsInArea, filters);
        
        return diff.map(unit => {
            return {
                ...unit,
                include: false
            }
        });
    }

    createFilters(units, allUnitsInArea) {
        //Get turnover
        const turnovers = this.createTurnOverFilter(units);
        const chains = this.createChainFilter(units, this.state.createDistrict.salesDistrictFilters.chains);
        const salesSpaceGroups = this.createRetailAreaFilter(units);

        const unitsIncludeExclude = this.unitsToExclude(units, this.state.units.filter(unit => allUnitsInArea.includes(unit.companyId)), {
            chains,
            turnovers,
            salesSpaceGroups
        });

        return {
            chains,
            turnovers,
            salesSpaceGroups,
            unitsIncludeExclude
        };
    }

    xslxRemoveSheetHiddenRows(sheet){
        let csv=XLSX.utils.sheet_to_csv(sheet,{skipHidden:true})
        let filteredWorkbook=XLSX.read(csv, {type: 'binary'});
        return filteredWorkbook.Sheets.Sheet1;
    }

    parseFile(e, importFileType) {
        e.preventDefault();

        this.setState({
            isOpen: true,
            importFileType
        }, () => {
            setTimeout(() => {
                this.setState({
                    isLoading: true
                });
                
                const files = e.target.files, f = files[0];
                const reader = new FileReader();
                reader.onload = async (e) => {
                    const data = e.target.result;
                    let workbook = XLSX.read(data, {type: 'binary', cellStyles: true });
                    const temp_wsname = workbook.SheetNames[0];
                    const temp_ws = workbook.Sheets[temp_wsname];
                    const csv = XLSX.utils.sheet_to_csv(temp_ws,{skipHidden:true});
                    const filteredWorkbook = XLSX.read(csv, {type: 'binary'});
                    
                    const wsname = filteredWorkbook.SheetNames[0];
                    const ws = filteredWorkbook.Sheets[wsname];
                    /* Convert array to json*/
                    const dataParse = XLSX.utils.sheet_to_json(ws, { header:1 });
    
                    if (dataParse && dataParse.length > 0 && dataParse[0].length > 0) {
    
                        const units = await this.fetchUnits(this.props.type);
                        const createDistrict = await this.fetchNewDistrict(this.props.type, '');
    
                        this.setState({
                            isLoading: false,
                            document: dataParse,
                            units,
                            createDistrict,
                            view: this.getView(this.state.step),
                            step: this.state.step+1
                        });
                    } else {
                        this.setState({
                            isError: true,
                            isLoading: false,
                            errorMessage: 'Vi kunde inte förstå formatet på din excelfil. Försök igen eller kontakta Delfi för support.'
                        });
    
                        return;
                    }
                };
                reader.readAsBinaryString(f);

            }, 300);
        });

        
    }

    setColumnDistrictIndex(districtColumnIndex) {
        this.setState({
            districtColumnIndex,
            view: this.getView(this.state.step),
            step: this.state.step+1
        });
    }

    setColumnDelfiIdIndex(unitColumnIndex) {
        this.setState({
            isLoading: true
        });
        
        const unitsInDocument = this.getAllDataRows();
        const columnDataToMatch = this.getColumnData(unitsInDocument, unitColumnIndex);
        const matchedUnits = this.matchUnits(columnDataToMatch);
        const unMatchedUnits = this.unMatchedUnits(matchedUnits, columnDataToMatch);

        this.setState({
            unitColumnIndex,
            matchedUnits,
            unMatchedUnits,
            view: this.getView(this.state.step),
            step: this.state.step+1,
            isLoading: false
        });
    }

    setScenario(scenarioId, scenarioName) {
        if (scenarioId !== '') {
            this.setState({
                scenarioId,
                view: this.getView(this.state.step),
                step: this.state.step+1
            });

            return;
        } 

        this.setState({
            scenarioName,
            view: this.getView(this.state.step),
            step: this.state.step+1
        });

        return;
    }

    matchUnits(unitsToMatch) {
        const matchedUnits = this.state.units.filter(unit => unitsToMatch.includes(unit.delfiId) || unitsToMatch.includes(unit.ediNumber*1));
        return matchedUnits;
    }

    unMatchedUnits(matchedUnits, unitsInDocument) {
        const unMatched  = [];
        const matchedDelfiIds = matchedUnits.map(unit => unit.delfiId);
        const matchedEdiNumbers = matchedUnits.map(unit => unit.ediNumber*1);
        unitsInDocument.forEach(unit => {
            if (!matchedDelfiIds.includes(unit) && !matchedEdiNumbers.includes(unit)) {
                unMatched.push(unit);
            }
        });

        return unMatched;
    }

    getColumns() {
        return this.state.document[0];
    }

    getColumnData(dataRows, columnIndex) {
        //Get column
        return dataRows.map(item => {
            return item[columnIndex];
        });
    }

    getDistrictNames(columnIndex) {
        const data = this.getAllDataRows();
        
        const districtColumn = this.getColumnData(data, columnIndex);
        
        const districts = [...new Set(districtColumn)];
        return districts;
    }

    getAllDataRows() {
        return this.state.document.filter((item, i) => i > 0);
    }

    setColumnForDistricts(districtColumnIndex) {
        this.setState({
            isLoading: true,
            districtColumnIndex
        });

        const districtNames = this.getDistrictNames(districtColumnIndex);
        const allDataRows = this.getAllDataRows();
        const districts = districtNames.map(item => {
            const unitsInDataTableByDistrict = allDataRows.filter(row => row[districtColumnIndex] === item).map(obj => obj[this.state.unitColumnIndex]);
            const matchedUnitsByDistrict = this.matchUnits(unitsInDataTableByDistrict);
            
            return {
                name: item,
                color: this.createRandomHexColor(),
                units: matchedUnitsByDistrict,
                isLoading: false,
                isFinished: false,
                load: 0
            };
        });

        this.setState({
            isLoading: false,
            view: this.getView(this.state.step),
            step: this.state.step+1,
            districts
        });
    }

    async getFeaturesFromGeoType(geoType) {
        if (this.state.features[geoType]) {
            return this.state.features[geoType];
        }

        return await this.fetchGeoJSON(`${REACT_APP_GEOJSON_LOCATION}/${geoType}.json`);
    }

    async setGeoLayer(geoType) {
        this.setState({
            isLoading: true
        });



        const geoJSON = [...this.state.features];
        geoJSON[geoType] = await this.getFeaturesFromGeoType(geoType);
    
        const districts = this.state.districts && this.state.districts.map(item => {
            return {
                ...item,
                features: geoJSON[geoType].features,
                geoType
            }
        });

        

        this.setState({
            geoType,
            view: this.getView(this.state.step),
            step: this.state.step+1,
            features: geoJSON,
            districts,
            isLoading: false
        });
    }

    createWorker(message, loading) {
        return new Promise((resolve) => {
            const workerInstance = new Worker(new URL('./helpers/worker.js', import.meta.url));
            workerInstance.postMessage(message);
            workerInstance.onmessage = (event) => {
                const {type, ...rest } = event.data;
                if (type === 'save') {
                    resolve(rest);
                }

                if (type === 'loading') {
                    loading(rest)
                }
            };
        });
    }

    createRandomHexColor() {
        return '#000000'.replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
    }

    getGeoType(type) {
        switch (type) {
            case 'zip1':
            case 'zip2':
            case 'zip3':
            case 'zip5':
                return 'postalCodes';
            case 'postalcity':
                return 'localities';
            default:
                return type;
        }
    }

    async createDistricts() {

        this.setState({
            isCreating: true
        });

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        //Do wee need to create a new scenario?
        let salesDistrictScenarioId = 0;
        if (this.state.scenarioName !== '') {

            const scenarios = [
                ...this.props.scenarios,
                { 
                    salesDistrictScenarioId,
                    name: this.state.scenarioName,
                    sortOrder: Math.max(...this.props.scenarios.map(item => item.sortOrder*1)) + 1
                }
            ];

            const rawResponseScenario = await fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    scenarios
                })
            });
    
            if (rawResponseScenario.ok) {
                const result = await rawResponseScenario.json();
                salesDistrictScenarioId = result.scenarios[result.scenarios.length-1].salesDistrictScenarioId;
            } else {
                this.setState({
                    isError: true,
                    isLoading: false,
                    errorMessage: 'Vi kunde inte skapa scenario. Försök igen eller kontakta Delfi support.'
                });

                return;
            }

        } else {
            salesDistrictScenarioId = this.state.scenarioId;
        }

        for (const [index, districtFromExcel] of [...this.state.districts].entries()) {
            
            const districts = [...this.state.districts];
            districts[index].isLoading = true;

            this.setState({
                districts
            });

            let selectedFeatures = [];
            let allUnitsInFeature = [];
            let salesDistrictFilters = {
                ...this.state.createDistrict.salesDistrictFilters
            };
            if (this.state.importFileType === 'geo') {
                selectedFeatures = districtFromExcel.selectedFeatures;
            } else {
                districtFromExcel.units.forEach(unit => {
                    for (let i = 0; i<districts[index].features.length; i++) {
                        if (selectedFeatures.some(feature => feature.id === districts[index].features[i].id)) {
                            continue;
                        }
                        
                        if (districts[index].features[i].properties.units.includes(unit.companyId)) {
                            selectedFeatures.push(districts[index].features[i]);
                            allUnitsInFeature = [...allUnitsInFeature, ...districts[index].features[i].properties.units]
                            break;
                        }
                    }
                });

                //Create filters
                salesDistrictFilters = this.createFilters(districtFromExcel.units, allUnitsInFeature);
            }

            //Caclulate total area and create multi polygon overlay
            let turfPolygons = [];
            turfPolygons[districts[index].geoType] = featureCollectionToTurfPolygons({ features: districts[index].features });
            

            const data = await this.createWorker({ 
                selectedAreas: featureCollectionToTurfPolygons({ features: selectedFeatures }).map(item => item.feature), 
                turfPolygons: turfPolygons
            }, ({ percentage }) => {
                districts[index].load = percentage;
                this.setState({
                    districts
                });
            });

            const { spatialGeoJson , salesDistrictArea, ...saveObj } = data;

            if (spatialGeoJson) {
                spatialGeoJson.properties = {
                    ...spatialGeoJson.properties,
                    color: districtFromExcel.color,
                    name: districtFromExcel.name
                };
            }

            const objForSave = {
                ...this.state.createDistrict,
                name: districtFromExcel.name,
                color: districtFromExcel.color,
                spatialGeoJson: JSON.stringify([spatialGeoJson]),
                salesDistrictArea,
                salesDistrictScenarioId,
                salesDistrictFilters,
                ...saveObj,
                units: this.state.importFileType === 'geo' ? saveObj.units : districtFromExcel.units.map(unit => unit.companyId)
            };

            //Save!!
            const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrict/create/${this.props.type}`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ...objForSave
                })
            });

            if (rawResponse.ok) {
                await rawResponse.json();
                districts[index].isLoading = false;
                districts[index].isFinished = true;
                districts[index].load = 100;
                this.setState({
                    districts
                });
            
            } else {
                this.setState({
                    isError: true,
                    isLoading: false,
                    errorMessage: 'Något gick fel när vi skulle skapa distriktet. Försök igen eller kontakta Delfi support.'
                });
                break;
            }
        }

        setTimeout(() => {
            window.location.href = this.props.type === 'foodservice' ? `/foodservice-scenario/${salesDistrictScenarioId}` : `/scenario/${salesDistrictScenarioId}`;       
        }, 1500);
    }

    setColumnForGeoLayer(geoColumnIndex) {
        this.setState({
            geoColumnIndex,
            view: this.getView(this.state.step),
            step: this.state.step+1
        });
    }

    normalizePostals(zip) {
        if (!zip) return '';

        return zip.toString().replace(/\D/g, '');
    }

    testar(districtColumnIndex) {
        this.setState({
            isLoading: true,
            districtColumnIndex
        });
        
        const districtNames = this.getDistrictNames(districtColumnIndex);
        const allDataRows = this.getAllDataRows();
        const districts = districtNames.map(item => {
            const geoItemsInDataTableByDistrict = [...new Set(allDataRows.filter(row => row[districtColumnIndex] === item).map(obj => this.getGeoType(this.state.geoType) === 'postalCodes' ?  this.normalizePostals(obj[this.state.geoColumnIndex]) : obj[this.state.geoColumnIndex].toLowerCase()))];
            const selectedFeatures = this.state.features[this.state.geoType].features.filter(feature => {
                const name = this.state.geoType === 'postalCodes' ? feature.properties.name : feature.properties.name.toLowerCase();
                return geoItemsInDataTableByDistrict.includes(name);
            });

            const allUntypedUnitsInFeatures = [].concat(...selectedFeatures.map(feature => feature.properties.units));
            const allTypedUnitsInFeatures = this.state.units.filter(unit => allUntypedUnitsInFeatures.includes(unit.companyId)).map(unit => unit.companyId)
            return {
                name: item,
                color: this.createRandomHexColor(),
                units: allTypedUnitsInFeatures,
                selectedFeatures: selectedFeatures,
                features: this.state.features[this.state.geoType].features,
                geoType: this.state.geoType,
                isLoading: false,
                isFinished: false,
                load: 0
            };
        });

        this.setState({
            isLoading: false,
            view: this.getView(this.state.step),
            step: this.state.step+1,
            districts
        });
    }

    getView(step) {
        if (this.state.importFileType === 'geo') {
            return this.geoWizardViewOrder[step];
        } else {
            return this.unitsWizardViewOrder[step];
        }
    }

    getHeader() {

        const totaltSteps = this.state.importFileType === 'geo' ?  this.geoWizardViewOrder.length : this.unitsWizardViewOrder.length;

        return (
            <>
                Importera säljdistrikt
                <span className="import__step">
                    {this.state.step === 0 ? `1/${totaltSteps}` : `${this.state.step}/${totaltSteps}`}
                </span>
            </>
        );
    }

    getGeoLayerName(layer) {
        switch(layer) {
            case 'zip5':
                return 'postnummer';
            case 'county':
                return 'län';
            case 'municipality':
                return 'Kommuner';
            case 'aregion':
                return 'A-regioner';
            case 'postalcity':
                return 'postorter';
            default:
                return '';
        }
    }

    getFullGeoLayerName(geoType) {
        switch (geoType) {
            case 'zip1':
                return '1-siffrigt postnummer';
            case 'zip2':
                return '2-siffrigt postnummer';
            case 'zip3':
                return '3-siffrigt postnummer';
            case 'zip5':
                return '5-siffrigt postnummer';
            case 'county':
                return 'Län';
            case 'municipality':
                return 'Kommun';
            case 'aregion':
                return 'A-region';
            case 'postalcity':
                return 'Postort';
            default: 
            return '';
        }
    }

    async changeGeoTypeForDistrict(districtId, geoType, cb = null) {
        
        this.setState({
            isLoading: true
        });

        const geoJSON = [...this.state.features];
        geoJSON[geoType] = await this.getFeaturesFromGeoType(geoType);

        //const geoJSON = await this.fetchGeoJSON(`${REACT_APP_GEOJSON_LOCATION}/${geoType}.json`);

        const districts = this.state.districts.map(item => {
            if (item.name === districtId) {
                return {
                    ...item,
                    geoType,
                    features: geoJSON[geoType].features
                }
            }

            return {
                ...item
            }
        });
        
        this.setState({
            districts,
            features: geoJSON,
            isLoading: false
        }, () => {
            if (cb) {
                cb();
            }
        });
    }

    toggleEditModal() {
        //Reset state
        this.setState({
            isOpen: false,
            isError: false,
            isLoading: false,
            isCreating: false,
            createDistrict: null,
            units: null,
            geoType: '',
            features: null,
            matchedUnits: null,
            districts: null,
            document: null,
            view: 0,
            unitColumnIndex: '',
            districtColumnIndex: '',
            scenarioId: '',
            scenarioName: ''
        });
    }

    render() {
        
        return (
            <div className={classNames({
                'import':true,
                'import--is-loading':this.state.isLoading
            })}>
                <form>
                    <DropdownButton 
                        buttonChildren={<span className="import__upload-text">Importera säljdistrikt…</span>}
                        controls="import-dropdown"
                        modifiers={{
                            'import__upload': true,
                            'import__upload--is-loading': this.state.isLoading
                        }}>
                        <li>
                            <label className="import__upload-item">
                                <input type="file" 
                                    onChange={(e) => this.parseFile(e, 'unit')}
                                    accept=".xlsx, .xls" 
                                    disabled={this.state.isLoading} />
                                    Importera butiker från fil
                                    <SpinnerDots />
                            </label>
                        </li>
                        <li>
                            <label className="import__upload-item">
                                <input type="file" 
                                    onChange={(e) => this.parseFile(e, 'geo')}
                                    accept=".xlsx, .xls" 
                                    disabled={this.state.isLoading} />
                                    Importera geografi från fil
                                    <SpinnerDots />
                            </label>
                        </li>
                    </DropdownButton>  
                </form>

                <Takeover modifiers={{
                    'takeover--no-margin': true,
                    'takeover--wide-small': true
                }} isOpen={this.state.isOpen} toggleTakeover={() => this.toggleEditModal()} heading={this.getHeader()}>
                    {!this.state.isError && this.state.view === 1 &&
                        <View1 columns={this.getColumns()} 
                               onNext={(val) => this.setColumnDelfiIdIndex(val)} 
                               unitColumnIndex={this.state.unitColumnIndex} 
                               type={this.props.type} />
                    }
                    {!this.state.isError && this.state.view === 2 &&
                        <View2 allRows={this.getAllDataRows()} 
                               matchedUnits={this.state.matchedUnits} 
                               unMatchedUnits={this.state.unMatchedUnits}
                               columns={this.getColumns()} 
                               onNext={(colIndex) => this.setColumnForDistricts(colIndex)} 
                               districtColumnIndex={this.state.districtColumnIndex}
                               prevStep={() => this.prevStep()} 
                               type={this.props.type}/>
                    }

                    {!this.state.isError && this.state.view === 3 && 
                        <View3 onNext={(type) => this.setGeoLayer(type)} 
                               geoType={this.state.geoType}
                               prevStep={() => this.prevStep()} 
                               type={this.props.type} />
                    }

                    {!this.state.isError && this.state.view === 4 && 
                        <View4 onNext={(type) => this.setGeoLayer(type)} 
                               geoType={this.state.geoType} 
                               type={this.props.type} />
                    }

                    {!this.state.isError && this.state.view === 5 &&
                        <View5 columns={this.getColumns()}
                               geoColumnIndex={this.state.geoColumnIndex} 
                               geoLayerName={this.getGeoLayerName(this.state.geoType)} 
                               prevStep={() => this.prevStep()}
                               onNext={(colIndex) => this.setColumnForGeoLayer(colIndex)} 
                               type={this.props.type} />
                    }

                    {!this.state.isError && this.state.view === 6 &&
                        <View6 columns={this.getColumns()}
                               districtColumnIndex={this.state.districtColumnIndex}
                               onNext={(colIndex) => this.testar(colIndex)} 
                               prevStep={() => this.prevStep()} 
                               type={this.props.type} />                    
                    }

                    {!this.state.isError && this.state.view === 7 &&
                        <View7 scenarios={this.props.scenarios} 
                               onNext={(id, name) => this.setScenario(id, name)} 
                               prevStep={() => this.prevStep()} 
                               scenarioId={this.state.scenarioId}
                               scenarioName={this.state.scenarioName} 
                               type={this.props.type} />
                    }

                    {!this.state.isError && this.state.view === 8 &&
                        <View8 districts={this.state.districts} 
                               changeGeoTypeForDistrict={(districtId, geoType, cb) => this.changeGeoTypeForDistrict(districtId, geoType, cb)}
                               onNext={() => this.createDistricts()} 
                               prevStep={() => this.prevStep()} 
                               getFullGeoLayerName={(geoType) => this.getFullGeoLayerName(geoType)}
                               importFileType={this.state.importFileType}
                               isCreating={this.state.isCreating} 
                               type={this.props.type} />
                    }
                    {this.state.isError &&
                        <IsError errorMessage={this.state.errorMessage} />
                    }
                    <SpinnerDots />
                </Takeover>
            </div>
        );
    }
};

export default withAuthProvider(withFetch(Import));